import { Alert, Box, LinearProgress, Paper, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { AppState } from '../../../store/rootReducer';

import TallenesTaleTableToolbar from './TallenesTaleTableToolbar';
import TallenesTaleListKunde from './TallenesTaleListKunde';
import TallenesTaleListOther, { OTHER_VISNINGER } from './TallenesTaleListOther';


const useStyles = makeStyles()(() => ({
  root: { marginTop: '12px', fontSize: '1em !important', color: '#456456', },
}),
);

//
export default function TallenesTaleReport() {
  const { classes } = useStyles();
  const visningType: string = useSelector((state) => (state as AppState).tallenesTale.visningType);
  const isFetchingSalesReport: boolean = useSelector((state) => (state as AppState).tallenesTale.isFetchingSalesReport);
  const salesReportError: string = useSelector((state) => (state as AppState).tallenesTale.salesReportError);

  return (
    <div className={classes.root} >
      <Paper elevation={0} sx={{ backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '6px', padding: '14px 20px', margin: '0 20px 12px 20px' }} >
        <TallenesTaleTableToolbar />
      </Paper>
      {/* A big store's report takes some seconds: say so (like SS12 / SS13). */}
      {isFetchingSalesReport ? (
        <Box role="status" aria-live="polite" sx={{ margin: '0 20px 12px 20px' }}>
          <LinearProgress />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>Henter salgsstatistikk… dette kan ta noen sekunder.</Typography>
        </Box>
      ) : null}
      {/* Cleared by the next "Hent salgsstatistikk". */}
      {salesReportError ? (
        <Alert severity="error" sx={{ margin: '0 20px 12px 20px' }}>
          {salesReportError}
        </Alert>
      ) : null}
      {/* "Største endringer i kroner" and the result table are their own cards, below the filter card. A key
          per visning, so each keeps its own column choice, search and sorting. */}
      {visningType === 'Kunde' ? <TallenesTaleListKunde /> : null}
      {OTHER_VISNINGER.includes(visningType) ? <TallenesTaleListOther key={visningType} visning={visningType} /> : null}
    </div>
  )
}
